import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import Router from "./router/router";
import {
	captureEmbedQueryParams,
	getEmbedMode,
	isEmbedMode,
} from "./utils/embed";

import styles from "./App.module.scss";

const VTEX_STATE_KEY = "jv_vtex_oauth_state";
const VTEX_CLIENT_KEY = "jv_vtex_oauth_client_id";
const VTEX_REDIRECT_KEY = "jv_vtex_oauth_redirect_uri";

/**
 * Captures VTEX Custom OAuth query params on first load and sends users to login.
 * See https://developers.vtex.com/docs/guides/login-integration-guide-webstore-oauth2
 */
function VtexOAuthBootstrap() {
	const navigate = useNavigate();
	const location = useLocation();

	useEffect(() => {
		const params = new URLSearchParams(window.location.search);
		const state = params.get("state");
		if (!state) {
			return;
		}
		sessionStorage.setItem(VTEX_STATE_KEY, state);
		const cid = params.get("client_id");
		if (cid) {
			sessionStorage.setItem(VTEX_CLIENT_KEY, cid);
		}
		const ru = params.get("redirect_uri");
		if (ru) {
			sessionStorage.setItem(VTEX_REDIRECT_KEY, ru);
		}
		const path = location.pathname || "";
		if (path === "/" || path === "") {
			navigate("/login", { replace: true });
		} else if (path === "/login") {
			navigate("/login", { replace: true });
		}
	}, [location.pathname, navigate]);

	return null;
}

/**
 * WordPress iframe embed: hide heavy landing assets path by routing to login/register.
 */
function EmbedBootstrap() {
	const navigate = useNavigate();
	const location = useLocation();

	useEffect(() => {
		captureEmbedQueryParams();
		if (!isEmbedMode()) {
			return;
		}

		const mode = getEmbedMode();
		const path = location.pathname || "";
		if (path !== "/" && path !== "") {
			return;
		}

		if (mode === "register") {
			navigate("/register/validate-identity", { replace: true });
			return;
		}

		navigate("/login", { replace: true });
	}, [location.pathname, navigate]);

	return null;
}

const App = () => {
	return (
		<div className={styles.App}>
			<VtexOAuthBootstrap />
			<EmbedBootstrap />
			<Router />
		</div>
	);
};

export default App;
